import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {BloodTransfusionComponent} from './blood-transfusion.component';
import {RequisitionListComponent} from './requisition-list/requisition-list.component';
import {DonarListComponent} from './donar-list/donar-list.component';

const routes: Routes = [
    {
        path: '', component: BloodTransfusionComponent,
        children: [
            {path: 'blood_transfusion/requisition_list', component: RequisitionListComponent},
            {path: 'blood_transfusion/donar_list', component: DonarListComponent}
        ]
    }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/blood-transfusion/blood-transfusion.routing.ts